import { css } from 'styled-components';

export const Z_INDEX_HIGHEST = 300;
export const Z_INDEX_HIGHER = 200;
export const Z_INDEX_HIGH = 100;
export const Z_INDEX_NORMAL = 1;
export const Z_INDEX_LOW = -100;
export const Z_INDEX_LOWER = -200;

const SPACING_SIZE = 8;
/** @deprecated use SPACING[25] instead */
export const NANO_SPACING = SPACING_SIZE / 4;
/** @deprecated use SPACING[50] instead */
export const MICRO_SPACING = SPACING_SIZE / 2;
/** @deprecated use SPACING[100] instead */
export const SMALL_SPACING = SPACING_SIZE;
/** @deprecated use SPACING[100] or SPACING[200] instead */
export const SEMI_MEDIUM_SPACING = SPACING_SIZE + MICRO_SPACING;
/** @deprecated use SPACING[200] instead */
export const MEDIUM_SPACING = SPACING_SIZE * 2;
/** @deprecated use SPACING[300] instead */
export const LARGE_SPACING = SPACING_SIZE * 3;
/** @deprecated use SPACING[400] instead */
export const EXTRA_LARGE_SPACING = SPACING_SIZE * 4;

const DEFAULT_SIZE_MULTIPLIER = 8;
export const EXTRA_SMALL_HEIGHT = DEFAULT_SIZE_MULTIPLIER * 3;
export const SMALL_HEIGHT = DEFAULT_SIZE_MULTIPLIER * 4;
export const MEDIUM_HEIGHT = DEFAULT_SIZE_MULTIPLIER * 5;
export const LARGE_HEIGHT = DEFAULT_SIZE_MULTIPLIER * 6;

export const ELLIPSIS = `
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export const BACKGROUND_OVERLAY = css`
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    top: 0;
    left: 0;
`;
